export default "__VITE_ASSET__DlUD61bI__"